<template>
  <div class="single-page-1">
    <m-single-content-wrapper :content-link="contentLink">
      <template v-slot="{content}">
        <div class="container-fluid py-4">
          <img class="w-100 p-0 m-0 single-page-1-main-image" :src="content.thumbnail" :alt="content.title">
          <div class="col-lg-12 m-n5 mx-auto p-0 m-0 p-lg-4 p-md-4">
            <div class="shadow bg-white text-dark single-page-1-body rounded rounded-4">
              <h1>{{ content.title }}</h1>
              <m-html-to-component-wrapper :template="processContent(content.body)"/>
            </div>
          </div>

        </div>
      </template>

    </m-single-content-wrapper>
  </div>

</template>

<script>
import mSingleContentWrapper from "../../Wrappers/SingleContentWrapper";
import mHtmlToComponentWrapper from "../../Wrappers/HtmlToComponentWrapper";

export default {
  name: "SinglePost1",
  components: {mSingleContentWrapper, mHtmlToComponentWrapper},
  data() {
    return {
      temp: `<iframe v-resize width="100%" src="https://formafzar.com/form/e74qp" frameborder="0" ></iframe>   `
    }
  },
  props: {
    contentLink: {
      default: null
    }
  },
};
</script>

<style>
.single-page-1-body img {
  width: 100%;
}
</style>

<style scoped>
.single-page-1-body{
  padding: 15px;
}
.single-page-1-main-image {
  width: 100%;
  height: 450px;
  object-fit: cover;
}


.single-page-1 :deep(video) {
  height: auto;
  width: 100%;
  margin: auto;
  position: relative;
  display: block;
  padding: 0;
  overflow: hidden;
}

</style>